var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.selected)?_c('img',{attrs:{"src":require("../../assets/arrowFillRightOrienIcon.svg"),"alt":"ArrowGrayFilledIcon"}}):_c('img',{attrs:{"src":require("../../assets/arrowOutlineRightOrienIcon.svg"),"alt":"ArrowOutLineIcon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }